export default "__VITE_ASSET__BTOP8MyY__"